import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { SalesforceBundle } from "~/api/models/Bundle";
import { ProductImage } from "~/api/models/ProductDetails";
import { useFetchOpportunity } from "~/api/salesForce/useFetchOpportunity";
import { useFetchBundleFromCms } from "~/api/storyblok/useFetchBundleFromCms";
import Subtitle from "~/components/atoms/Subtitle/Subtitle";
import OfferCard from "~/components/molecules/OfferCard/OfferCard";
import { getImageBasedOnGender } from "~/utils";
import BundleCardProduct from "./BundleCardProduct";

type BundleCardProps = {
  bundle?: SalesforceBundle;
};

const BundleCard = ({ bundle }: BundleCardProps) => {
  const { opportunityId } = useParams();
  const { data: opportunity, isLoading: loadingOpportunity } =
    useFetchOpportunity({
      id: opportunityId as string,
    });
  const intl = useIntl();
  const { data } = useFetchBundleFromCms(bundle);
  const customGetImageBasedOnGender = (image?: ProductImage) => {
    return getImageBasedOnGender({
      image,
      opportunityGender: opportunity?.gender,
    });
  };

  return (
    <AnimatePresence>
      {!loadingOpportunity && bundle && (
        <OfferCard
          benefits={data?.hideBenefits ? [] : data?.benefits}
          treatments={
            <>
              {bundle.bundleProducts.map((bundleProduct) => (
                <BundleCardProduct
                  key={bundleProduct.productCode}
                  bundleProduct={bundleProduct}
                  customGetImageBasedOnGender={customGetImageBasedOnGender}
                />
              ))}
            </>
          }
          title={bundle.name}
          price={intl.formatMessage(
            { id: "pricing.amount" },
            { amount: bundle.getPrice(true) }
          )}
          image={{
            male: data?.maleImage,
            female: data?.femaleImage,
          }}
          opportunityGender={opportunity?.gender}
        >
          {/* <EditableSkinBundle editable={opportunity?.isValidForSales} /> */}
          <Subtitle className="text-grey-400" level={3}>
            {bundle.bundleProducts.map((product) => product.name).join(", ")}
          </Subtitle>
        </OfferCard>
      )}
    </AnimatePresence>
  );
};

export default BundleCard;
